/**
 * V2.4 mission activity registry. Flood Rescue keeps its tested reference flow.
 * All missions reuse the same activity navigation / Swan context / author gates.
 */
import { FLOOD_RESCUE_FLOW, getFloodRescueActivityState } from "./floodRescueWholeJourney";
import { OTHER_WONDERLABS_FLOW } from "./otherWonderLabsWholeJourneys";
import { ROBOT_ARTIST_EXPLORERS_FLOW } from "./robotArtistExplorersFlow";
import { FOOD_DELIVERY_ROBOT_FLOW } from "./foodDeliveryRobotFlow";
import { MAGNETWORKS_FLOW } from "./magnetworksFlow";

export const WONDERLABS_FLOW = { ...FLOOD_RESCUE_FLOW, ...OTHER_WONDERLABS_FLOW, ...ROBOT_ARTIST_EXPLORERS_FLOW, ...FOOD_DELIVERY_ROBOT_FLOW, ...MAGNETWORKS_FLOW };

export const getWonderLabsActivityState = (stepId, sessionState, completionState) => {
  if (Object.prototype.hasOwnProperty.call(FLOOD_RESCUE_FLOW, stepId)) {
    return getFloodRescueActivityState(stepId, sessionState, completionState);
  }
  const specs = WONDERLABS_FLOW[stepId] || [];
  const items = completionState?.items || [];
  const activities = specs.map((spec) => {
    const applicable = items.filter((item) => spec.blockIds.includes(item.targetBlockId));
    const unassigned = items.filter((item) => !item.targetBlockId);
    const outstanding = applicable.find((item) => !item.complete) ||
      (spec === specs[specs.length - 1] ? unassigned.find((item) => !item.complete) : null);
    const galleryReview = stepId === "wind-car-explain" && spec.id === "step10-story";
    const saved = sessionState?.steps?.[stepId] || {};
    const viewed = new Set([
      ...(Array.isArray(saved.final_image_examined_viewed) ? saved.final_image_examined_viewed : []),
      ...(saved.final_image_examined ? [saved.final_image_examined] : []),
    ]);
    const galleryPending = galleryReview && !completionState?.allComplete && viewed.size < 3;
    return { ...spec, missing: [], required: applicable.length,
      missingLabel: galleryPending ? `View all three system pictures (${viewed.size} of 3 viewed)` :
        outstanding?.label || (outstanding?.field
        ? `Complete ${outstanding.field.replace(/_/g, " ")}` : ""),
      complete: !galleryPending && applicable.every((item) => item.complete) &&
        (spec === specs[specs.length - 1] ? unassigned.every((item) => item.complete) : true),
    };
  });
  const firstIncomplete = activities.findIndex((item) => !item.complete);
  return { activities,
    maxUnlockedIndex: firstIncomplete < 0 ? Math.max(0, activities.length - 1) : firstIncomplete,
    allComplete: firstIncomplete < 0,
  };
};
